/**
 * Maximum display-label length for an entity reference published in assistant context.
 * Labels are untrusted render-only text and must never be interpreted as instructions.
 */
export const ASSISTANT_ENTITY_CONTEXT_LABEL_MAX_CHARACTERS = 120;
